import { makeSelector } from 'containers/app/selectors'

const deskBookings = (state) => state.getIn(['app', 'user', 'deskBookings'])

export const getDeskBookings = makeSelector(deskBookings)
